(function () {
  'use strict';

  var STORAGE_PREFIX = 'mtm_';

  function MTMDrawer() {
    this.drawer      = document.getElementById('mtm-drawer');
    this.overlay     = document.getElementById('mtm-overlay');
    this.trigger     = document.getElementById('mtm-trigger');
    this.savedEl     = document.getElementById('mtm-saved');
    this.editBtn     = document.getElementById('mtm-edit');
    this.closeBtn    = document.getElementById('mtm-close');
    this.form        = document.getElementById('mtm-form');
    this.unitHidden  = document.getElementById('mtm-unit-hidden');
    this.warning     = document.getElementById('mtm-warning');
    this.howToToggle = document.querySelector('.MTMHowTo__Toggle');
    this.howToBody   = document.getElementById('mtm-howto-body');

    if (!this.drawer) return;

    this.productId   = this.drawer.dataset.productId;
    this.currentUnit = 'inches';
    this.lastFocus   = null;
    this.warnShown   = false;

    this._bindEvents();
    this._setMinDeliveryDate();
    this._restoreFromSession();
  }

  MTMDrawer.prototype._bindEvents = function () {
    var self = this;

    if (this.trigger) {
      this.trigger.addEventListener('click', function () { self.open(); });
    }
    if (this.editBtn) {
      this.editBtn.addEventListener('click', function () { self.open(); });
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', function () { self.close(); });
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function () { self.close(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) {
        self.close();
      }
    });

    if (this.howToToggle && this.howToBody) {
      this.howToToggle.addEventListener('click', function () {
        var expanded = self.howToToggle.getAttribute('aria-expanded') === 'true';
        self.howToToggle.setAttribute('aria-expanded', String(!expanded));
        self.howToBody.hidden = expanded;
      });
    }

    document.querySelectorAll('.MTMUnitToggle__Option').forEach(function (btn) {
      btn.addEventListener('click', function () { self._setUnit(btn.dataset.unit); });
    });

    if (this.form) {
      this.form.addEventListener('submit', function (e) { self._handleSubmit(e); });
    }

    /* Size swatch changes — prompt before clearing MTM */
    document.querySelectorAll('.SizeSwatch__Radio').forEach(function (radio) {
      radio.addEventListener('change', function () { self._handleSizeChange(); });
    });

    /* Inject MTM properties before Add to Cart fires */
    var addBtn = document.querySelector('[data-action="add-to-cart"]');
    if (addBtn) {
      addBtn.addEventListener('click', function () { self._injectProperties(); }, true);
    }
  };

  MTMDrawer.prototype.open = function () {
    this.lastFocus = document.activeElement;
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mtm-open');
    this._trapFocus();

    var self = this;
    requestAnimationFrame(function () {
      var first = self.drawer.querySelector('button:not([disabled]), input, select, textarea');
      if (first) first.focus();
    });
  };

  MTMDrawer.prototype.close = function () {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mtm-open');
    this._releaseFocus();
    if (this.lastFocus) this.lastFocus.focus();
  };

  MTMDrawer.prototype._trapFocus = function () {
    var self = this;
    this._focusTrap = function (e) {
      if (e.key !== 'Tab') return;
      var nodes = Array.prototype.slice.call(self.drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    };
    document.addEventListener('keydown', this._focusTrap);
  };

  MTMDrawer.prototype._releaseFocus = function () {
    if (this._focusTrap) {
      document.removeEventListener('keydown', this._focusTrap);
      this._focusTrap = null;
    }
  };

  MTMDrawer.prototype._setUnit = function (unit) {
    this.currentUnit = unit;
    if (this.unitHidden) this.unitHidden.value = unit;

    document.querySelectorAll('.MTMUnitToggle__Option').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.unit === unit);
    });

    document.querySelectorAll('.MTMField__Unit').forEach(function (span) {
      span.textContent = '(' + unit + ')';
    });
  };

  MTMDrawer.prototype._setMinDeliveryDate = function () {
    var input = document.getElementById('mtm-delivery');
    if (!input) return;
    var d = new Date();
    d.setDate(d.getDate() + 28);
    input.min = d.toISOString().split('T')[0];
  };

  MTMDrawer.prototype._getFormData = function () {
    if (!this.form) return {};
    var data = {};
    var els = this.form.elements;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.name && el.value && el.value.trim()) {
        data[el.name] = el.value.trim();
      }
    }
    return data;
  };

  MTMDrawer.prototype._handleSubmit = function (e) {
    e.preventDefault();
    e.stopPropagation();

    /* Clear previous errors */
    this.form.querySelectorAll('.MTMField__Input').forEach(function (inp) {
      inp.classList.remove('is-error');
    });
    if (this.warning) this.warning.hidden = true;

    /* Required field validation */
    var heightEl = document.getElementById('mtm-height');
    var fitEl    = document.getElementById('mtm-fit');
    var valid    = true;

    if (heightEl && !heightEl.value.trim()) { heightEl.classList.add('is-error'); valid = false; }
    if (fitEl && (!fitEl.value || fitEl.value === '')) { fitEl.classList.add('is-error'); valid = false; }

    if (!valid) {
      var firstErr = this.form.querySelector('.is-error');
      if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    /* Soft warning: if >50% of measurement fields are empty */
    var measureInputs = Array.prototype.slice.call(
      this.form.querySelectorAll('input[type="number"]')
    ).filter(function (inp) { return inp.id !== 'mtm-height'; });

    if (measureInputs.length > 0 && !this.warnShown) {
      var filled = measureInputs.filter(function (inp) { return inp.value.trim(); }).length;
      if (filled / measureInputs.length < 0.5) {
        this.warnShown = true;
        if (this.warning) this.warning.hidden = false;
        return; /* First submit shows warning; second submit proceeds */
      }
    }

    /* Save */
    var data = this._getFormData();
    sessionStorage.setItem(STORAGE_PREFIX + this.productId, JSON.stringify(data));

    this._updatePDPState(true);
    this.warnShown = false;
    this.close();
  };

  MTMDrawer.prototype._updatePDPState = function (active) {
    if (active) {
      if (this.trigger)  this.trigger.style.display  = 'none';
      if (this.savedEl)  this.savedEl.classList.add('is-visible');

      var form = document.querySelector('.ProductForm');
      if (form) form.classList.add('ProductForm--mtm-active');

      document.querySelectorAll('.MTMLeadTime').forEach(function (el) {
        el.textContent = 'Made to measure — crafted in 4 weeks from our Noida atelier.';
      });
    } else {
      if (this.trigger) this.trigger.style.display = '';
      if (this.savedEl) this.savedEl.classList.remove('is-visible');

      var form = document.querySelector('.ProductForm');
      if (form) form.classList.remove('ProductForm--mtm-active');

      document.querySelectorAll('.MTMLeadTime').forEach(function (el) {
        el.textContent = '3 weeks from order, made to order in our Noida atelier.';
      });
    }
  };

  MTMDrawer.prototype._restoreFromSession = function () {
    var raw = sessionStorage.getItem(STORAGE_PREFIX + this.productId);
    if (!raw) return;
    try {
      var data = JSON.parse(raw);
      var form = this.form;
      if (form) {
        Object.keys(data).forEach(function (name) {
          var val = data[name];
          var els = form.elements;
          for (var i = 0; i < els.length; i++) {
            if (els[i].name === name) { els[i].value = val; break; }
          }
        });
        if (data['_unit']) this._setUnit(data['_unit']);
      }
      this._updatePDPState(true);
    } catch (err) {
      sessionStorage.removeItem(STORAGE_PREFIX + this.productId);
    }
  };

  MTMDrawer.prototype._handleSizeChange = function () {
    var raw = sessionStorage.getItem(STORAGE_PREFIX + this.productId);
    if (!raw) return;
    var confirmed = window.confirm('Switch to standard sizing? Your saved measurements will be cleared.');
    if (confirmed) {
      sessionStorage.removeItem(STORAGE_PREFIX + this.productId);
      this.warnShown = false;
      this._updatePDPState(false);
    }
  };

  MTMDrawer.prototype._injectProperties = function () {
    var raw = sessionStorage.getItem(STORAGE_PREFIX + this.productId);
    if (!raw) return;
    var productForm = document.querySelector('.ProductForm');
    if (!productForm) return;

    try {
      var data = JSON.parse(raw);
      /* Remove any previously injected MTM property inputs */
      productForm.querySelectorAll('input[data-mtm-prop]').forEach(function (el) { el.remove(); });

      Object.keys(data).forEach(function (key) {
        var val = data[key];
        if (!val) return;
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + key + ']';
        inp.value = val;
        inp.setAttribute('data-mtm-prop', '1');
        productForm.appendChild(inp);
      });
    } catch (err) {
      /* silent */
    }
  };

  /* Boot */
  function init() { new MTMDrawer(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
